const ZohoMenuTypes = {
    USER_MAPPING: {
        id: "usermapping",
        group: "settings_group",
        path: "user-mapping",
        label: "User Mapping",
        tabs: [],
        implemented: true,
    },
};

export default ZohoMenuTypes;
